import {unref} from "vue";
import {useComElState} from "@/main-page/ctls/hooks/useComElState";
import {useVuexState} from "@/main-page/ctls/hooks/useVuexState";
import {CtlComEnum} from "@/main-page/enums/ctlComEnum";

export function useFieldDefHooks({column, pItemType,
                                     componentKey, record}) {
    const model = ref({key: unref(column).dataIndex});
    /**
     * 公式定义
     */
    const {vuex} = useVuexState({
        sectionConfig: column,
        record: unref(record),
        vuexProps: ['showCtl', 'disabled', CtlComEnum.DEFAULT_SET]
    });

    const {initDefValue} = useComElState({
        vuexState: vuex,
        pItemType,
        componentKey,
        model,
        props: column,
        pModelObj: record
    });



    onMounted(() => {
        initDefValue();
    })


    return {
        model
    }
}
